import { Injectable, inject } from '@angular/core';
import { filter, map, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { loadHolidays } from '../actions/holidays.actions';
import { selectHolidaysState } from '../selectors/holidays.selector';
import { HolidaysState } from '../reducers/holidays.reducer';
import { BoelsReservation } from '@boels/models';

@Injectable()
export class HolidaysFacade {
  private readonly store = inject(Store);

  getHolidays(
    startDate: string,
    endDate: string,
  ): Observable<BoelsReservation | undefined> {
    this.store.dispatch(
      loadHolidays({
        startDate: startDate,
        endDate: endDate,
      }),
    );
    return this.store.select(selectHolidaysState).pipe(
      filter(
        (holidayState) =>
          (!holidayState.loading && holidayState.success) || holidayState.error,
      ),
      map((holidayState: HolidaysState) => holidayState.holidays),
    );
  }

  /**
   * Converts Date Object to yyyy-mm-dd formatted string. (iso code 8601)
   * @param date Date Object which has to be converted.
   */
  convertToIsoCode8601(date: Date): string {
    return date.toISOString().split('T')[0];
  }
}
